<template>
  <div v-loading="formLoading" class="firstStep">
    <el-form
      :model="extForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="开户银行：" prop="accountBank">
            <el-input
              placeholder="请输入开户行"
              v-model="extForm.accountBank"
              maxlength="50"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="银行账号：" prop="bankNumber">
            <el-input
              placeholder="请输入银行账号"
              v-model="extForm.bankNumber"
              minlength="1"
              maxlength="30"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="开票地址：" prop="billingAddress">
            <el-input
              placeholder="请输入开票地址"
              v-model="extForm.billingAddress"
              maxlength="50"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开票电话：" prop="billingPhone">
            <el-input
              placeholder="请输入开票电话"
              v-model="extForm.billingPhone"
              maxlength="13"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item
            class="addTableList addTabIndex"
            label=""
            style="float: left"
            prop="desc"
          >
            <el-form
              :model="{ extTable }"
              :rules="rules1"
              ref="ruleForm1"
              class="demo-ruleForm"
            >
              <el-table
                border
                :data="extTable"
                class="ccui-form-child-table"
                max-height="99999"
                style="position:relative;left:20px;"
              >
                <el-table-column prop="year" label="年份">
                  <template slot-scope="scope">
                    <el-form-item
                      style="margin:0;"
                      width="20%"
                      :prop="`extTable.${scope.$index}.year`"
                      :rules="rules1.year"
                    >
                      <el-date-picker
                        style="width: 110px;"
                        v-model="scope.row.year"
                        value-format="yyyy"
                        type="year"
                        placeholder="选择年"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column prop="businessIncome" label="营业收入（万元）">
                  <template slot-scope="scope">
                    <el-form-item
                      width="20%"
                      style="margin:0;"
                      :prop="`extTable.${scope.$index}.businessIncome`"
                      :rules="rules1.businessIncome"
                    >
                      <el-input
                        type="number"
                        style="width: 110px;"
                        v-model.number="scope.row.businessIncome"
                        placeholder="请输入"
                        clearable
                        oninput="if(value.length > 13) value=value.slice(0, 13)"
                      />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column prop="taxAmount" label="纳税额（万元）">
                  <template slot-scope="scope">
                    <el-form-item
                      width="20%"
                      style="margin:0;"
                      :prop="`extTable.${scope.$index}.taxAmount`"
                      :rules="rules1.taxAmount"
                    >
                      <el-input
                        type="number"
                        @click.native="centerDialogVisible = true"
                        style="width: 110px;"
                        v-model.number="scope.row.taxAmount"
                        placeholder="请输入"
                        clearable
                        oninput="if(value.length > 13) value=value.slice(0, 13)"
                      />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column prop="profit" label="利润（万元）">
                  <template slot-scope="scope">
                    <el-form-item
                      width="20%"
                      style="margin:0px !important;"
                      :prop="`extTable.${scope.$index}.profit`"
                      :rules="rules1.profit"
                    >
                      <el-input
                        type="number"
                        @click.native="centerDialogVisible = true"
                        style="width: 110px;"
                        v-model.number="scope.row.profit"
                        placeholder="请输入"
                        clearable
                        oninput="if(value.length > 13) value=value.slice(0, 13)"
                      />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column
                  fixed="right"
                  align="center"
                  :show-overflow-tooltip="true"
                  prop="remark"
                  label="操作"
                >
                  <template slot-scope="scope">
                    <span
                      style="color: red; cursor: pointer;"
                      @click="deleteItem(scope)"
                      >删除</span
                    >
                  </template>
                </el-table-column>
              </el-table>
            </el-form>
            <div class="addBtn" @click="addTable()">+添加财务信息</div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item>
        <el-button @click="submitForm('ruleForm')">提交</el-button>
        <el-button class="stopBtn" @click="saveForm()">暂存</el-button>
        <el-button class="lastBtn" @click="lastStep('ruleForm')"
          >上一步</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { registerSubconChangeInfos } from "@/api/subcontractor-register";
export default {
  props: {
    thirdStepId: "",
    extForm: {
      type: Object,
      default: () => {
        return {};
      }
    },
    extTable: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      formLoading: false,
      rules: {
        accountBank: [
          { required: true, message: "请输入开户银行", trigger: "blur" }
        ],
        billingAddress: [
          { required: true, message: "请输入开票地址", trigger: "blur" }
        ],
        billingPhone: [
          { required: true, message: "请输入开票电话", trigger: "blur" }
          // {
          //   pattern: /^\d{3}\d{7,8}|\d{4}\d{7,8}$/,
          //   message: "目前只支持座机号码"
          // }
        ],
        bankNumber: [
          { required: true, message: "请输入银行账号", trigger: "blur" },
          // 一般由6－12位数字组成。最多可以使用12位数字。
          {
            //pattern: /^([1-9]{1})(\d{14}|\d{18})$/,
            pattern: /^[0-9]\d*$/,
            message: "银行卡号不正确"
          }
        ]
      },
      rules1: {
        year: [{ required: true, message: "请输入年份", trigger: "blur" }],
        businessIncome: [
          { required: true, message: "请输入营业收入（万元）", trigger: "blur" }
        ],
        taxAmount: [
          { required: true, message: "请输入纳税额（万元）", trigger: "blur" }
        ],
        profit: [
          { required: true, message: "请输入利润（万元）", trigger: "blur" }
        ]

        // bankNumber: [
        //   { required: true, message: "请输入银行账号", trigger: "blur" },
        //   // 一般由6－12位数字组成。最多可以使用12位数字。
        //   {
        //     pattern: /[1-9]\d{12,18}/,
        //     message: "银行卡号不正确",
        //   },
        // ],
      }
    };
  },
  mounted() {},
  methods: {
    lastStep() {
      this.$emit("getStep", 1);
    },
    changePicker(date, row) {
      this.extTable[row.id - 1].year = this.getDate(date);
    },
    // 获取事件
    getDate(dateData) {
      let date = new Date(dateData);
      let y = date.getFullYear();
      return y;
    },
    saveForm() {
      var qualificationListTmp = [];
      if (this.extTable && this.extTable.length > 0) {
        this.extTable.forEach(e => {
          var tmp = Object.assign({}, e);
          tmp.createTime = "";
          tmp.updateTime = "";
          qualificationListTmp.push(tmp);
        });
      }
      var that = this;
      this.formLoading = true;
      registerSubconChangeInfos({
        subconChangeInfo: {
          accountBank: that.extForm.accountBank,
          bankNumber: that.extForm.bankNumber,
          billingAddress: that.extForm.billingAddress,
          billingPhone: that.extForm.billingPhone,
          country: that.extForm.country,
          province: that.extForm.province,
          city: that.extForm.city,
          county: that.extForm.county,
          attribute2: that.extForm.attribute2,
          id: that.thirdStepId
        },
        subconTyPerChange: qualificationListTmp
      }).then(
        res => {
          this.formLoading = false;
          if (res.data.data.code === "0") {
            this.$message({
              showClose: true,
              type: "success",
              message: "暂存成功",
              ccuiCustom: true
            });
          } else {
            this.$message({
              showClose: true,
              type: "error",
              message: res.data.data.message,
              ccuiCustom: true
            });
          }
        },
        error => {
          this.formLoading = false;
        }
      );
    },
    submitForm(formName) {
      var qualificationListTmp = [];
      if (this.extTable && this.extTable.length > 0) {
        this.extTable.forEach(e => {
          var tmp = Object.assign({}, e);
          tmp.createTime = "";
          tmp.updateTime = "";
          qualificationListTmp.push(tmp);
        });
      }
      var that = this;
      this.$refs["ruleForm1"].validate(valid => {
        if (valid) {
          this.$refs[formName].validate(valid => {
            if (valid) {
              this.formLoading = true;
              registerSubconChangeInfos({
                subconChangeInfo: {
                  accountBank: that.extForm.accountBank,
                  bankNumber: that.extForm.bankNumber,
                  billingAddress: that.extForm.billingAddress,
                  billingPhone: that.extForm.billingPhone,
                  id: that.thirdStepId,
                  country: that.extForm.country,
                  province: that.extForm.province,
                  city: that.extForm.city,
                  county: that.extForm.county,
                  attribute2: that.extForm.attribute2,
                  checkState: 3,
                  registeredType: 0,
                  subconAuditStatus:1
                },
                subconTyPerChange: qualificationListTmp
              }).then(
                res => {
                  let { code, message } = res.data.data;
                  this.formLoading = false;
                  this.$emit("getStep", 3);
                  if (code === "0") {
                  this.$router.push("/subcon-submit-success");
                  } else {
                    this.$message({
                      showClose: true,
                      type: "error",
                      message: message,
                      ccuiCustom: true
                    });
                  }
                },
                error => {
                  this.formLoading = false;
                }
              );
            } else {
              this.$emit("open");
              console.log("error submit!!");
              return false;
            }
          });
        } else {
          this.$emit("open");
          console.log("error submit!!");
          return false;
        }
      });
    },
    addTable() {
      if (this.extTable && this.extTable.length === 0) {
        this.extTable.push({
          id: 1
        });
      } else {
        this.extTable.push({
          id: this.extTable[this.extTable.length - 1].id + 1
        });
      }
    },
    deleteItem(scope) {
      this.extTable.filter((item, index) => {
        if (item.id === scope.row.id) {
          this.extTable.splice(index, 1);
        }
      });
    }
  },
  watch: {}
};
</script>

<style lang="scss" scoped>
/deep/ .el-table td,
.el-table th {
  padding: 0px;
  input {
    margin-top: 5px;
  }
}
.el-form-item__content {
  margin: 0 !important;
}
.addTabIndex[data-v-1df87990] .el-form-item__content tbody tr {
  height: 55px !important;
}
.firstStep .el-form {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  left: -20px;
  .el-row {
    width: 770px !important;
  }
  .el-form-item {
    font-size: 14px !important;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85) !important;
    /deep/.el-form-item__label {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.85);
    }
  }
  .el-form-item__content .el-input /deep/input,
  .el-select /deep/.el-input input {
    float: left;
    height: 40px;
    background: #ffffff;
    border-radius: 2px;
    border: 1px solid #e9ecf7;
  }
  // /deep/.el-form-item__content,
  // /deep/.el-form-item__content .e-input {
  //   width: 435px;
  //   .el-form-item__error {
  //     padding: 0;
  //   }
  // }
  .el-form-item__content .el-button {
    width: 82px;
    height: 40px;
    background: #ff152e;
    border-radius: 2px;
    font-size: 14px;
    border: none;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
  }
  .el-form-item__content .stopBtn {
    background: rgba(255, 21, 46, 0.08);
    border: 1px solid #ff152e;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ff152e;
  }
  .el-form-item__content .lastBtn {
    background: #fafafa;
    border: 1px solid #dddddd;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.25);
  }
  .addTableList /deep/.el-form-item__content {
    // border: 1px solid #e9ecf7;
    tr {
      height: 45px;
    }
    .addBtn {
      cursor: pointer;
      width: 100%;
      height: 32px;
      border: 1px dashed #eee;
      border-radius: 4px;
      margin: 16px 0;
      text-align: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #252631;
    }
  }
  .verificationCode {
    width: 435px;
    display: flex;
    .el-button {
      width: 102px;
      height: 40px;
      background: #ffffff;
      border-radius: 2px;
      border: 1px solid #e9ecf7;
      margin-left: 15px;
    }
    /deep/.el-input,
    /deep/.el-input input {
      width: 335px !important;
      height: 40px;
    }
  }
  .el-table {
    /deep/tbody tr {
      height: 45px !important;
    }
    /deep/thead tr th {
      div {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
      }
    }
    /deep/.el-table__body-wrapper .el-table__body tbody tr td div {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.65);
    }
  }
}
</style>
